import type { App } from 'vue'

interface E2eTestIdOptions {
  name: string
  suffix: string
}

export default {
  install (app: App): void {
    function createTestId ({ name, suffix }: E2eTestIdOptions): string {
      return `${name.replace('.', '-')}-${suffix}`
    }
    app.config.globalProperties.$e2e = {
      createTestId: createTestId,
    }
  },
}
